import { FC, Fragment, useEffect, useState } from 'react';
import { Modal, Button as AntButton } from 'antd';
import { ICourse } from '../../../../models/courses.model';
import SelectSemesterCourseSubject from '../../../SelectSemesterCourseSubject';
import { ISubject } from '../../../../models/subject.model';
import { IClassSubjectReq } from '../../../../models/campusClasses.model';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface IProps {
  courseInfo: ICourse;
  scheduleInput: any;
  subjects?: ISubject[];
  semester: any;
  onOk: (req: IClassSubjectReq[]) => void;
  onClose: () => void;
  onSetScheduleClassesInput: (
    id: string,
    key: string,
    value: any,
  ) => void;
}

const ClassSubjectModal: FC<IProps> = ({
  courseInfo: { weekLectureCount, dayLessonCount, courseDetailName },
  scheduleInput,
  subjects,
  onOk,
  onClose,
  onSetScheduleClassesInput,
  semester
}) => {
  const { t } = useTranslation();
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { semesters } = useSelector((state: RootState) => state.semester);
  const { currentSemesterCode } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  // 임시
  const { auth } = useSelector((state: RootState) => state.auth);  

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    const campus = campusData.find(campus => campus.campusCode === chosenClass?.campusCode);
    const _semester = semesters?.find(_semester => _semester.semesterCode === (semester ?? currentSemesterCode));

    if(_semester?.semesterType === 'SC') {
      if(campus?.testYn === 'Y' ||
        chosenClass && moment((chosenClass as any)?.classSrtDate).subtract("4", 'd').isAfter(moment(serverDate))
      ) {
        setIsSubmitDisabled(false);
      }
    } else {
      if (
        // 임시조건: auth?.webId === 'xingsoft'
        auth?.webId === 'xingsoft' ||
        campus?.testYn === 'Y' ||
        (_semester && moment(_semester?.semesterSrtDate).subtract("9", 'd').isAfter(moment(serverDate)))
      ) {
        setIsSubmitDisabled(false);
      }
    }
  }, [chosenClass, campusData, semesters, currentSemesterCode]);

  const onSubmit = () => {
    const req: IClassSubjectReq[] = [];

    scheduleInput.forEach((schedule: any) => {
      schedule.classes.forEach((classItem: any) => {
        req.push({
          classTimeCode: classItem.classTimeCode,
          subjectCode: classItem.subjectCode,
        });
      });
    });

    onOk(req);
  };

  const _response = scheduleInput?.reduce((acc: any, item: any) => {
    if (acc[item.day]) {
      acc[item.day] = [...acc[item.day], ...item.classes];
      return acc;
    }

    acc[item.day] = [...item.classes];
    return acc;
  }, {})

  return (
    <Modal
      title={t('class.class.17')}
      visible
      onCancel={onClose}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSubmit}
            disabled={isSubmitDisabled}
          >
            {t('common.button.save')}
          </AntButton>
        </div>
      ]}
    >
      <div className='comm-bx__space'>
        <h3 className='sub-title'>{courseDetailName}</h3>
      </div>
      <div className='comm-table__area rowType mt-0'>
        <table>
          <colgroup>
            <col width="70px" />
            <col width="50px" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th className="text-center">{t('class.class.9')}</th>
              <th className="text-center">{t('class.class.18')}</th>
              <th className="text-center">{t('class.class.10')}</th>
            </tr>
            {
              Object.keys(_response).map((key, index) => {
                const classInfo = _response[key];
                return (
                  <Fragment key={index}>
                    <tr>
                      <td className="text-center" rowSpan={classInfo.length + 1}>
                        Day {index + 1}
                      </td>
                    </tr>
                    {
                      classInfo.map((c: any, subIndex: number) => {
                        return (
                          <tr key={subIndex}>
                            <td className="text-center">{subIndex + 1}</td>
                            <td className="text-center">
                              <SelectSemesterCourseSubject
                                subjectCode={c.subjectCode}
                                setSubjectCode={(value) => {
                                  onSetScheduleClassesInput(c.id, 'subjectCode', value);
                                }}
                                subjects={subjects}
                              />
                            </td>
                          </tr>
                        )
                      })
                    }
                  </Fragment>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default ClassSubjectModal;